import { apiClient } from "../../../shared/api/client";
import { ENDPOINTS } from "../../../../legacy/network/endpoints";
import { GetTransactionMetricsParams, TransactionAnalytics } from "../types";

/**
 * Fetches transaction metrics from the `/v1/admin/transaction/metrics` endpoint.
 * Accepts optional filtering parameters such as period and currency.
 */
export const getTransactionMetrics = async (
  params?: GetTransactionMetricsParams
): Promise<TransactionAnalytics> => {
  try {
    const response = await apiClient.get(ENDPOINTS.TRANSACTION_METRICS, {
      params,
    });
    const payload = response?.data?.data ?? response?.data ?? {};
    return payload as TransactionAnalytics;
  } catch (error) {
    console.error("[getTransactionMetrics] Failed to load transaction metrics:", error);
    throw error;
  }
};
